import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestService } from '../shared/providers/rest.service'
import { IStatesList } from '../shared/models/StatesListOutputModel'
import { IUserInput } from '../shared/models/UserInputModel';
import { IUser } from '../shared/models/user';
import { ICities } from '../shared/models/CitiesListOutputModel'
import { IUserRole } from '../shared/models/UserRoleOutputModel';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { IBrokerRegionalLicenses } from '../shared/models/BrokerRegionalLicensesInputModel';
import { IUserCreationResponseModel } from '../shared/models/UserCreationResponseModel';
import { FileUploadService } from '../shared/providers/fileupload.service';
import { IFileUpload } from '../shared/models/fileupload';
import { ValidationService } from '../shared/providers/validation.service';
import { ToastService } from '../shared/providers/toast.service'
import { CommonService } from '../shared/providers/common.service'
import { AuthenticationService } from '../shared/auth/authentication.service';
import { UserRole } from '../shared/enum/enum';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { LoaderService } from '../shared/providers/loader.service';


@Component({
  selector: 'user-add',
  templateUrl: './profile-edit.component.html',

})
export class UserProfileEditComponent implements OnInit {

  statesList: IStatesList[];
  citiesList: ICities[];
  userRoleList: IUserRole[];
  lookupList: ILookUp[];
  userRole = UserRole;
  userInputModel = {} as IUserInput;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  fileUploadType: string = "single";
  fileExtensionType: string = "image";
  inputFileUpload = {} as IFileUpload;
  DefaultIndexCount: number = 0;
  userGuid: string = "0";
  userDetailsOutput = {} as IUserDetails;
  public sourcepage: string = 'My Profile';

  IsEditMode: boolean = false;
  authResponse = {} as IUser;
  result = [];
  brokerRegionalLicenses: Array<IBrokerRegionalLicenses> = [];
  private newAttribute: any = {};
  showPropertyAssociated: boolean = false;
  ShowbrokerRegionalLicenses = false;
  imageIdToDelete: number;
  deleteTask: string;
  deleteTaskId: number;
  brokerageValid: boolean = true;
  modalRef: BsModalRef;


  @ViewChild('profilePic') profilePic: ElementRef;

  constructor(private Loader: LoaderService, private propertyListing: PropertyListingService, private _restService: RestService, private _userManagerService: UserManagerService, private _fileUploadService: FileUploadService, private router: Router,
    public validationService: ValidationService, private activatedRoute: ActivatedRoute, private _toastService: ToastService,
    private _commonService: CommonService, public _authenticationService: AuthenticationService, private modalService: BsModalService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userGuid = params['user'];
      if (params['sourcepage'] != null) {
        this.sourcepage = params['sourcepage'];
      }
      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
    });

  }

  addFieldValue() {
    this.brokerRegionalLicenses.push(this.newAttribute)
    this.newAttribute = {};
    //setting state drop down value as  --select---
    for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {
      if ((i + 1) == this.brokerRegionalLicenses.length) {
        this.brokerRegionalLicenses[i].StateId = 0;
      }
    }
  }

  deleteFieldValue(index: any, Id: number) {
    if (Id !== undefined) {
      this._userManagerService.CheckBrokerLicenseUsed(Id).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Can not delete this license since it is already used in a propery.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        else {
          this.brokerRegionalLicenses.splice(index, 1);
        }
      });
    }
    else {
      this.brokerRegionalLicenses.splice(index, 1);
    }
  }

  selectedFiles: string[] = [];
  clearFiles: number = 0;

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    console.log(selectedFilesListEmitter);
    this.selectedFiles = selectedFilesListEmitter;
  }
  selectedFilePathEmitter(selectedFilePathEmitter: any) {
    this.profilePic.nativeElement.src = selectedFilePathEmitter;
  }
  openModalBrokerage(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  setUploadDefaultValues() {
    this.inputFileUpload.fileCategoryId = 251;
    this.inputFileUpload.id = 0;
    this.inputFileUpload.objectId = 0;
    this.inputFileUpload.objectTypeId = 301;
    this.inputFileUpload.documentName = "User Profile Pictuer";
    this.inputFileUpload.type = "Images";
  }

  uploadFiles() {

    this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFiles).subscribe(response => {
      this.clearFiles++;
      this.redirectToListingPage();
    });
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.saveUser();
    }
  }

  IsSeller = false;
  tickers = [];
  isDisableRole = true;

  ngOnInit() {

    let loggedInUserGuid = '';
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    loggedInUserGuid = loggedUserDetails.Guid;
    if (loggedInUserGuid !== this.userGuid) {
      this.router.navigate(['/']);
    }

    this.setUploadDefaultValues();



    this._commonService.getStateList().subscribe(response => {
      this.statesList = response.map(o => { return { Id: o.Id, Name: o.StateName }; });
    });

    this._commonService.getLookupsByTypeId(1).subscribe(response => {
      this.lookupList = response.filter(x => x.Id != 103).map(o => { return { id: o.Id, description: o.Description }; });
    });

    this.userInputModel.StateId = 0;
    this.userInputModel.CityId = 0;
    this.userInputModel.UserRoleId = 0;
    this.userInputModel.UserStatus = 0;

    if (this.userGuid != undefined) {
      this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
        if (this._authenticationService.SuperAdmin()) {
          if ((response.UserRoleId === this.userRole.Admin || response.UserRoleId === this.userRole.SuperAdmin) && !response.IsDefaultSuperAdmin) {
            this.isDisableRole = false;
          }
        }

        this._commonService.getUserRolesList().subscribe(response => {
          let roleList = response.map(o => { return { id: o.Id, name: o.Description }; });
          if (!this.isDisableRole) {
            this.userRoleList = roleList?.filter(f => f.id == this.userRole.SuperAdmin || f.id == this.userRole.Admin)
          }
          else {
            this.userRoleList = roleList;
          }
        });

        
        ////console.log(response.BrokerRegionalLicensesOutputModelList);
        this.userInputModel.UserGuid = this.userGuid;
        var userId = response.Id;
        this.currentuserId = userId;
        this.userInputModel.FirstName = response.FirstName;
        this.userInputModel.LastName = response.LastName;
        this.userInputModel.EmailAddress = response.Email;
        this.userInputModel.PhoneNumber = response.Phoneno;
        this.userInputModel.Address1 = response.Address1;
        this.userInputModel.Address2 = response.Address2;
        this.userInputModel.StateId = response.StateId;
        this.bindCity();
        this.userInputModel.CityId = (response.CityId == null ? 0 : response.CityId);
        this.userInputModel.Zip = response.Zip;
        this.userInputModel.UserRoleId = response.UserRoleId;
        this.userInputModel.UserStatus = response.UserStatusId;
        this.userInputModel.ProfilePicPath = response.ProfilePicPath;
        this.userInputModel.UserRole = response.UserRole;
        this.userInputModel.CompanyName = response.CompanyName;
        this.imageIdToDelete = response.ImageId;
        this.userInputModel.UserLinkedInProfile = response.UserLinkedInProfile;

        if (this._authenticationService.Principal() || this._authenticationService.Principal1031() || this._authenticationService.Seller()) {
          this.userInputModel.UserRole = "Principal";
        }

        if (this.userInputModel.UserRoleId == this.userRole.DataEntryStaff) {
          this.userInputModel.BrokerageId = [];
          this._userManagerService.getBrokerages(userId).subscribe(response => {
            if (response != null) {
              this.result = response;

              //this.inputBrokerage = response.map(o => { return { id: o.Id, name: o.BrokerageName } });
              //this.userInputModel.BrokerageId = response.id;

              response.forEach(item => {
                this.userInputModel.BrokerageId.push(item.Id);

              });
            }

          });

        }
        if (this.userInputModel.UserRoleId == this.userRole.DataEntryStaff) {
          this._userManagerService.getBrokerages(userId).subscribe(response => {

            if (response != null) {
              this.result = response;
            }

          });
        }
        if (this.imageIdToDelete != null) {
          $('.profileupload')[0].hidden = true;
        }
        else {
          $('.profileupload')[0].hidden = false;
        }
        if (this.userInputModel.UserRoleId != UserRole.Principal && this.userInputModel.UserRoleId != UserRole.Principal1031) {
          //Converting  UTC Date into Local Date
          for (let i = 0; i < response.BrokerRegionalLicensesOutputModelList.length; i++) {
            let UTCDate = (response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate);
            if (!this.validationService.IsinValid(UTCDate)) {
              var date = new Date(UTCDate + ' UTC');
              response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate_Date = date;
            }
          }

          this.brokerRegionalLicenses = response.BrokerRegionalLicensesOutputModelList;
          this.ShowbrokerRegionalLicenses = true;
        }
        else {
          this.brokerRegionalLicenses = null;
          this.ShowbrokerRegionalLicenses = false;
        }
        this.IsEditMode = true;
        if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
        }

        if (this._authenticationService.Seller()) {
          this.IsSeller = true;
          this.GetTickersForThisUser();
        }
      });
    }

    if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
      this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
    }

  }
  currentuserId = 0;
  private GetTickersForThisUser() {
    this.propertyListing.GetDefaultTickers(this.currentuserId).subscribe(res => {
      this.tickers = res;
    });
  }

  bindCity() {
    this._commonService.getCitiesList(this.userInputModel.StateId).subscribe(response => {
      this.citiesList = response.map(o => { return { Id: o.Id, Name: o.CityName }; });
    });
    this.userInputModel.CityId = 0;
  }

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  emailValid: boolean = true;
  emailvalidation: string = "";
  passwordValid: boolean = true;
  phoneValid: boolean = true;
  roleValid: boolean = true;
  userStatusValid: boolean = true;
  showFNSpecCharVal = false;
  showLNSpecCharVal = false;
  linkedinValidation: string = "";
  specCharValMsg = '!@#$%^&*()_+\-=\[\]{};"\\|<>\/? not allowed';
  saveUser() {
    let IsValid: boolean = true;

    if (this.validationService.IsinValid(this.userInputModel.FirstName)) {
      this.firstNameValid = false;
      this.showFNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.FirstName)) {
        this.firstNameValid = false;
        IsValid = false;
        this.showFNSpecCharVal = true;
      }
      else {
        this.showFNSpecCharVal = false;
        this.firstNameValid = true;
      }

    }
    if ((this.userInputModel.UserRoleId == this.userRole.Broker ||
      this.userInputModel.UserRoleId == this.userRole.SuperAdmin ||
      this.userInputModel.UserRoleId == this.userRole.Admin
) && (this.isLinkedInUrlValid != null && !this.isLinkedInUrlValid)) {
      IsValid = false;
      this.linkedinValidation = "Invalid LinkedIn Url";
    }
    else {
      this.linkedinValidation = "";
    }
    if (this.validationService.IsinValid(this.userInputModel.LastName)) {
      this.lastNameValid = false;
      this.showLNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.LastName)) {
        this.lastNameValid = false;
        IsValid = false;
        this.showLNSpecCharVal = true;
      }
      else {
        this.showLNSpecCharVal = false;
        this.lastNameValid = true;
      }
    }
    if (this.validationService.IsinValid(this.userInputModel.PhoneNumber)) {
      this.phoneValid = false;
      IsValid = false;
    }
    else {
      this.phoneValid = true;
    }
    if (this.userInputModel.UserRoleId == this.userRole.DataEntryStaff) {
      if (this.userInputModel.BrokerageId == null) {
        this.brokerageValid = false;
        IsValid = false;
      }
    }
    if (this.validationService.IsinValid(this.userInputModel.UserRoleId)) {
      this.roleValid = false;
      IsValid = false;
    }
    else if (this.userInputModel.UserRoleId == 0) {
      this.roleValid = false;
      IsValid = false;
    }
    else {
      this.roleValid = true;
    }

    if (IsValid) {
      if (this.validationService.isPhoneNumber(this.userInputModel.PhoneNumber) == false) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Invalid phone number', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        IsValid = false;
        return;
      }
      if (!this.validationService.IsinValid(this.userInputModel.Zip)) {
        if (!this.validationService.IsValidZipCode(this.userInputModel.Zip)) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Invalid Zip Code', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          IsValid = false;
        }
        else {
          IsValid = true;
        }
      }
      if (this.brokerRegionalLicenses != null) {
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {

          if ((this.validationService.IsinValid(this.brokerRegionalLicenses[i].StateId) || this.validationService.IsinValid(this.brokerRegionalLicenses[i].BrokerLicense)) ||
            (this.brokerRegionalLicenses[i].StateId == 0 || this.brokerRegionalLicenses[i].BrokerLicense.trim().length <= 0)) {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'State and License No. are mandatory. Row No :' + (i + 1), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            IsValid = false;
            return;
          }
        }


        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {
          for (let j = 0; j < this.brokerRegionalLicenses.length; j++) {
            if ((i != j) && (this.brokerRegionalLicenses[i].StateId == this.brokerRegionalLicenses[j].StateId)) {
              this._toastService.addToast({ title: 'Error Occurred', msg: 'State Name can not duplicate', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              IsValid = false;
              return;
            }
          }
        }
      }

      let CountDefaultIndex = 0;
      if (this.brokerRegionalLicenses != null) {
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {

          if (this.brokerRegionalLicenses[i].IsDefault == true) {
            CountDefaultIndex++;
          }

          if (CountDefaultIndex > 1) {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select only 1 License No as Default', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            IsValid = false;
            break;
          }
          if (!this.validationService.IsinValid(this.brokerRegionalLicenses[i].ExpiryDate_Date)) {
            if (this.brokerRegionalLicenses[i].ExpiryDate_Date.toString() == "Invalid Date") {
              this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select correct date. Row No :' + (i + 1), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              IsValid = false;
              break;
            }
          }
        }
      }
    }

    if (IsValid) {

      if (this.selectedFiles.length > 0) {
        this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 5000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
      }

      if (this.brokerRegionalLicenses != null) {
        //Converting Local Date into UTC Date
        for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {

          if (!this.validationService.IsinValid(this.brokerRegionalLicenses[i].ExpiryDate_Date)) {
            let UTCDate = (this.brokerRegionalLicenses[i].ExpiryDate_Date.toUTCString());
            this.brokerRegionalLicenses[i].ExpiryDate = UTCDate;
          }
          else {

            this.brokerRegionalLicenses[i].ExpiryDate = null;
          }
        }
      }

      this.userInputModel.BrokerRegionalLicensesInputModel = this.brokerRegionalLicenses;
      if (!this.IsEditMode) {
        this._userManagerService.createUser(this.userInputModel).subscribe(response => {
          this.userCreationResponseModel = response;
          if (this.userCreationResponseModel.Success == true) {
            if (this.selectedFiles.length > 0) {
              this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
              this.inputFileUpload.id = this.userCreationResponseModel.Id;
              this.uploadFiles();
            }
            else {
              this.redirectToListingPage();
            }
          }
          else {
            this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
        });
      }
      else {

        this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
          this.userCreationResponseModel = response;

          if (this.userCreationResponseModel.Success == true) {
            if (this.selectedFiles.length > 0) {
              this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
              this.inputFileUpload.id = this.userCreationResponseModel.Id;
              this.uploadFiles();
            }
            else {
              this.redirectToListingPage();
            }
          }
          else {
            this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
        });
      }
    }
  }
  clearFeilds() {

    this.router.navigate(['/my-profile'], { queryParams: { user: this.userGuid, sourcePage: this.sourcepage } });
  }


  validateemail() {
    if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
    }
  }

  setDefault(event: any, index: number) {
    for (let i = 0; i < this.brokerRegionalLicenses.length; i++) {
      if (i != index) {
        this.brokerRegionalLicenses[i].IsDefault = false;
      }
    }
    if (event.target.checked) {
      this.DefaultIndexCount++;
    }
    else {
      this.DefaultIndexCount--;
    }
  }
  redirectToListingPage() {
    this._authenticationService.reloadUserDetails(true);
    this.router.navigate(['/my-profile'], { queryParams: { user: this.userCreationResponseModel.Guid.toString(), sourcePage: this.sourcepage } });
    this._toastService.addToast({ title: 'Success', msg: 'User Details Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
  }

  onRemoveImage(id: number) {
    if (id > 0) {
      //this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 5000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
      this._userManagerService.deleteImage(id).subscribe(response => {
        if (response.toString() === 'true') {
          this._toastService.addToast({
            title: 'Success',
            msg: 'Image deleted successfully!',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png';
          this.imageIdToDelete = null;
          $('.profileupload')[0].hidden = false;
          this._authenticationService.reloadUserDetails(true);
        } else {
          this._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Image could not be deleted',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error'
          });
        }
      });
    }
    else {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Image deleted successfully!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    }
  }

  openModalForDelete(template: TemplateRef<any>, classes, taskId: number, task: string) {
    this.deleteTask = task;
    this.deleteTaskId = taskId;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  modalRefAddTicker: BsModalRef;
  openAddTicker(template: TemplateRef<any>, classes: any) {
    this.modalRefAddTicker = this.modalService.show(template, { class: classes });
  }

  selectedTickerId = 0;
  selectedTickerindex = 0;
  modalRefRemoveTicker: BsModalRef;
  openModalForDeleteTicker(template: TemplateRef<any>, classes: any, tickerId, index) {
    this.selectedTickerId = tickerId;
    this.selectedTickerindex = index;
    this.modalRefRemoveTicker = this.modalService.show(template, { class: classes });
  }

  closeAddTickerModal() {
    this.GetTickersForThisUser();
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  isLinkedInUrlValid: boolean;
  linkedinurlvalid(isvalid: boolean) {
    this.isLinkedInUrlValid = isvalid;
  }

  removeTicker() {
    this.Loader.display(true);
    this.propertyListing.RemoveTickers(this.selectedTickerId).subscribe(res => {
      if (res["IsSuccess"]) {
        this._toastService.addToast({ title: 'Success', msg: 'Ticker removed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.Loader.display(true);
        this.tickers.splice(this.selectedTickerindex, 1);
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to remove tickers', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.modalRefRemoveTicker.hide();
      this.Loader.display(false);
    });
  }
}
